import { GLOBALMESSAGES } from "../constants/messages";
import { MENU_LABELS, ModuleName, ModuleNames } from "../data/constants";
import { MenuSection } from "../types/Menu";
import { UserModuleRolePermission } from "../types/UserModuleRolePermission";

export function buildMenuFromPermissions(permissions: UserModuleRolePermission[]): MenuSection[] {
  const visibleModules = permissions.filter(p => p.canView);

  const grouped = new Map<string, UserModuleRolePermission[]>();
  visibleModules.forEach(mod => {
    const key = mod.moduleHeaderName || GLOBALMESSAGES.GENERAL;
    if (!grouped.has(key)) {
      grouped.set(key, []);
    }
    grouped.get(key)?.push(mod);
  });


  let sectionId = 1;

  const menu: MenuSection[] = Array.from(grouped.entries()).map(([headerName, modules]) => ({
    id: sectionId++,
    title: headerName,
    icon: getSectionIcon(headerName),
    listItems: modules.map((mod, idx) => ({
      id: idx + 1,
      title: mod.moduleDisplayName || mod.moduleName || GLOBALMESSAGES.UNTITLED,
      url: mod.pageUrl || "#",
      icon: getModuleIcon(mod.moduleName || ""),
      moduleName: mod.moduleName
    })),
  }));

  return menu;
}

function isValidModuleName(name: string): name is ModuleName {
  return Object.values(ModuleNames).includes(name as ModuleName);
}

// Icon paths must stay root-absolute: a bare "audit.svg" resolves against the current URL,
// so on a nested route such as /hiring/postif it becomes /hiring/audit.svg and 404s.
// Filenames must also match the casing in /public — deployed hosting is case-sensitive.
function getModuleIcon(moduleName: string): string {
  if (!isValidModuleName(moduleName)) return "/activities.svg";
  switch (moduleName) {
    case ModuleNames.Recyclebin:
      return "/delete.svg";
    case ModuleNames.AuditLog:
      return "/audit.svg";
    case ModuleNames.Manage:
      return "/settings.svg";
    case ModuleNames.Activities:
      return "/activities.svg";
    case ModuleNames.ErrorLog:
      return "/error.svg";
    case ModuleNames.WorkflowLibrary:
      return "/workflow-library.svg";
    case ModuleNames.WorkflowBuilder:
      return "/workflow-builder.svg";
    case ModuleNames.WorkflowInstances:
    case ModuleNames.WorkflowMyWork:
      return "/workflow-instances.svg";
    default:
      return "/activities.svg";
  }
}


function getSectionIcon(headerName: string) {
  switch (headerName) {
    case MENU_LABELS.FILE_EXPLORER:
      return "/settings.svg";
    case MENU_LABELS.ADMIN:
      return "/admin.svg";
    default:
      return "/settings.svg";
  }
}